import { Button } from '@dsx-react/button';
import { useMessageFormatter } from '@dsx-react/i18n';
import { MdChevronLeft, MdChevronRight, MdExpandLess, MdExpandMore } from '@dsx-react/icon';
import { useMediaFeatures, classNames, useResizeObserver } from '@dsx-react/util';
import { createContext, useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';

var scroll_left$1 = "T' port";
var scroll_right$1 = "T' starboard";
var scroll_up$1 = "T' heavens";
var scroll_down$1 = "T' sea";
var enPT = {
	scroll_left: scroll_left$1,
	scroll_right: scroll_right$1,
	scroll_up: scroll_up$1,
	scroll_down: scroll_down$1
};

var scroll_left = "Scroll left";
var scroll_right = "Scroll right";
var scroll_up = "Scroll up";
var scroll_down = "Scroll down";
var enUS = {
	scroll_left: scroll_left,
	scroll_right: scroll_right,
	scroll_up: scroll_up,
	scroll_down: scroll_down
};

const messages = {
  'en-US': enUS,
  'en-PT': enPT
};
var messages$1 = messages;

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".HorizontalScrollable-module_wrapper__-2foB {\n  position: relative;\n  max-width: 100%;\n}\n\n.HorizontalScrollable-module_viewport__Nn5mr {\n  display: flex;\n  flex-direction: row;\n  overflow-x: auto;\n  white-space: nowrap;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  -webkit-mask-composite: source-in, xor;\n          mask-composite: intersect;\n  -webkit-mask-repeat: no-repeat;\n          mask-repeat: no-repeat;\n}\n.HorizontalScrollable-module_viewport__Nn5mr::-webkit-scrollbar {\n  display: none;\n}\n\n.HorizontalScrollable-module_viewport__Nn5mr.HorizontalScrollable-module_left__b3z3d {\n  -webkit-mask-image: linear-gradient(to right, transparent, transparent 44px, black 60px);\n          mask-image: linear-gradient(to right, transparent, transparent 44px, black 60px);\n}\n\n.HorizontalScrollable-module_viewport__Nn5mr.HorizontalScrollable-module_right__MnWNA {\n  -webkit-mask-image: linear-gradient(to left, transparent, transparent 44px, black 60px);\n          mask-image: linear-gradient(to left, transparent, transparent 44px, black 60px);\n}\n\n.HorizontalScrollable-module_viewport__Nn5mr.HorizontalScrollable-module_left__b3z3d.HorizontalScrollable-module_right__MnWNA {\n  -webkit-mask-image: linear-gradient(to right, transparent, transparent 44px, black 60px), linear-gradient(to left, transparent, transparent 44px, black 60px);\n          mask-image: linear-gradient(to right, transparent, transparent 44px, black 60px), linear-gradient(to left, transparent, transparent 44px, black 60px);\n}\n\n.HorizontalScrollable-module_arrow-left__FzObr,\n.HorizontalScrollable-module_arrow-right__2Dyun {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n.HorizontalScrollable-module_arrow-left__FzObr {\n  left: 0;\n}\n\n.HorizontalScrollable-module_arrow-right__2Dyun {\n  right: 0;\n}";
var styles$1 = {"wrapper":"HorizontalScrollable-module_wrapper__-2foB","viewport":"HorizontalScrollable-module_viewport__Nn5mr","left":"HorizontalScrollable-module_left__b3z3d","right":"HorizontalScrollable-module_right__MnWNA","arrow-left":"HorizontalScrollable-module_arrow-left__FzObr","arrow-right":"HorizontalScrollable-module_arrow-right__2Dyun"};
styleInject(css_248z$1);

const HorizontalScrollableContext = /*#__PURE__*/createContext({
  showLeftArrow: false,
  showRightArrow: false
});

function updateArrowVisibility$1(el, setShowLeftArrow, setShowRightArrow) {
  if (!el) {
    return;
  }
  setShowLeftArrow(el.scrollLeft > 0);
  setShowRightArrow(el.scrollLeft + el.clientWidth < el.scrollWidth);
}
function scroll$1(viewport, direction, smoothScrolling) {
  if (!viewport) {
    return;
  }

  // Space within this scroll margin on the left and right is considered to be "offscreen" in the below algorithm.
  const scrollMargin = 64;
  let newPosition;
  if (direction === 'right') {
    // Scroll right by one full viewport by default (this could happen if only a single child element exists)
    newPosition = viewport.scrollLeft + (viewport.clientWidth - 2 * scrollMargin);

    // Scroll so that an element partially in view on the right (or the first offscreen
    // element if no elements are partially in view) ends up at the far left.
    const viewportScrollRight = viewport.scrollLeft + viewport.clientWidth;
    for (const child of viewport.children) {
      const offsetRight = child.offsetLeft + child.clientWidth;
      // Element is at least partially offscreen to the right
      if (offsetRight > viewportScrollRight - scrollMargin) {
        // Element is not already scrolled to (this could happen if the element width exceeds the viewport width)
        if (child.offsetLeft - scrollMargin > viewport.scrollLeft) {
          newPosition = child.offsetLeft - scrollMargin;
          break;
        }
      }
    }
  } else {
    // Scroll left by one full viewport by default (this could happen if only a single child element exists)
    newPosition = viewport.scrollLeft - (viewport.clientWidth - 2 * scrollMargin);

    // Scroll so that an element partially in view on the left (or the first offscreen
    // element if no elements are partially in view) ends up at the far right.
    for (const child of [...viewport.children].reverse()) {
      const offsetRight = child.offsetLeft + child.clientWidth;
      // Element is at least partially offscreen to the left
      if (child.offsetLeft < viewport.scrollLeft + scrollMargin) {
        // Element is not already scrolled to (this could happen if the element width exceeds the viewport width)
        if (offsetRight + scrollMargin - viewport.clientWidth < viewport.scrollLeft) {
          newPosition = offsetRight + scrollMargin - viewport.clientWidth;
          break;
        }
      }
    }
  }
  if (smoothScrolling) {
    viewport.scrollTo({
      left: newPosition,
      top: 0,
      behavior: 'smooth'
    });
  } else {
    viewport.scrollLeft = newPosition;
  }
}

/**
 * A horizontally scrollable region that dynamically shows paging arrows based on scroll position.
 */
function HorizontalScrollable(props) {
  const {
    children,
    className: callerClassName,
    tag,
    viewportClassName: callerViewportClassName,
    viewportRole
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const {
    prefersReducedMotion
  } = useMediaFeatures();
  const smoothScrolling = typeof window !== 'undefined' && !prefersReducedMotion && 'scrollBehavior' in document.documentElement.style;
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const className = classNames('dsx-component', styles$1['wrapper'], callerClassName);
  const viewportClassName = classNames(styles$1['viewport'], showLeftArrow && styles$1['left'], showRightArrow && styles$1['right'], callerViewportClassName);
  const ref = useRef(null);

  // Needs to be regular effect instaed of layout effect.
  // Essentially after initial render check if arrows need to show
  // otherwise styles with transitions will flash from user-agent defaults
  // to specified styles
  useEffect(() => {
    if (ref.current !== null) {
      updateArrowVisibility$1(ref.current, setShowLeftArrow, setShowRightArrow);
    }
  }, [ref, setShowLeftArrow, setShowRightArrow]);
  useResizeObserver({
    ref,
    onResize: () => {
      if (!ref.current) {
        return;
      }
      updateArrowVisibility$1(ref.current, setShowLeftArrow, setShowRightArrow);
    }
  });
  const contextValue = useMemo(() => ({
    showLeftArrow,
    showRightArrow
  }), [showLeftArrow, showRightArrow]);
  const handleScrollLeft = useCallback(() => {
    scroll$1(ref.current, 'left', smoothScrolling);
  }, [ref, smoothScrolling]);
  const handleScrollRight = useCallback(() => {
    scroll$1(ref.current, 'right', smoothScrolling);
  }, [ref, smoothScrolling]);
  const handleViewportScroll = useCallback(e => {
    updateArrowVisibility$1(e.currentTarget, setShowLeftArrow, setShowRightArrow);
  }, [setShowLeftArrow, setShowRightArrow]);
  return /*#__PURE__*/jsx(HorizontalScrollableContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsxs("div", {
      className: className,
      "data-dsx--horizontal-scrollable": tag,
      children: [/*#__PURE__*/jsx("div", {
        className: viewportClassName,
        ref: ref,
        onScroll: handleViewportScroll,
        role: viewportRole,
        children: children
      }), showLeftArrow && /*#__PURE__*/jsx("div", {
        className: styles$1['arrow-left'],
        "data-dsx--horizontal-scrollable--left": tag,
        children: /*#__PURE__*/jsx(Button, {
          variant: "ui-control",
          size: "small",
          icon: MdChevronLeft,
          iconOnly: true,
          onClick: handleScrollLeft,
          children: formatMessage('scroll_left')
        })
      }), showRightArrow && /*#__PURE__*/jsx("div", {
        className: styles$1['arrow-right'],
        "data-dsx--horizontal-scrollable--right": tag,
        children: /*#__PURE__*/jsx(Button, {
          variant: "ui-control",
          size: "small",
          icon: MdChevronRight,
          iconOnly: true,
          onClick: handleScrollRight,
          children: formatMessage('scroll_right')
        })
      })]
    })
  });
}

var css_248z = ".VerticalScrollable-module_wrapper__aAz6- {\n  position: relative;\n  height: 100%;\n}\n\n.VerticalScrollable-module_viewport__wYgM3 {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  white-space: nowrap;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  -webkit-mask-composite: source-in, xor;\n          mask-composite: intersect;\n  -webkit-mask-repeat: no-repeat;\n          mask-repeat: no-repeat;\n}\n.VerticalScrollable-module_viewport__wYgM3::-webkit-scrollbar {\n  display: none;\n}\n\n.VerticalScrollable-module_viewport__wYgM3.VerticalScrollable-module_up__CE1cR {\n  -webkit-mask-image: linear-gradient(to bottom, transparent, transparent 44px, black 60px);\n          mask-image: linear-gradient(to bottom, transparent, transparent 44px, black 60px);\n}\n\n.VerticalScrollable-module_viewport__wYgM3.VerticalScrollable-module_down__-p3Sk {\n  -webkit-mask-image: linear-gradient(to top, transparent, transparent 44px, black 60px);\n          mask-image: linear-gradient(to top, transparent, transparent 44px, black 60px);\n}\n\n.VerticalScrollable-module_viewport__wYgM3.VerticalScrollable-module_up__CE1cR.VerticalScrollable-module_down__-p3Sk {\n  -webkit-mask-image: linear-gradient(to top, transparent, transparent 44px, black 60px), linear-gradient(to bottom, transparent, transparent 44px, black 60px);\n          mask-image: linear-gradient(to top, transparent, transparent 44px, black 60px), linear-gradient(to bottom, transparent, transparent 44px, black 60px);\n}\n\n.VerticalScrollable-module_arrow-up__0nlts,\n.VerticalScrollable-module_arrow-down__07pbJ {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n.VerticalScrollable-module_arrow-up__0nlts {\n  top: 0;\n}\n\n.VerticalScrollable-module_arrow-down__07pbJ {\n  bottom: 0;\n}";
var styles = {"wrapper":"VerticalScrollable-module_wrapper__aAz6-","viewport":"VerticalScrollable-module_viewport__wYgM3","up":"VerticalScrollable-module_up__CE1cR","down":"VerticalScrollable-module_down__-p3Sk","arrow-up":"VerticalScrollable-module_arrow-up__0nlts","arrow-down":"VerticalScrollable-module_arrow-down__07pbJ"};
styleInject(css_248z);

const VerticalScrollableContext = /*#__PURE__*/createContext({
  showUpArrow: false,
  showDownArrow: false
});

function updateArrowVisibility(el, setShowUpArrow, setShowDownArrow) {
  if (!el) {
    return;
  }
  setShowUpArrow(el.scrollTop > 0);
  setShowDownArrow(el.scrollTop + el.clientHeight < el.scrollHeight);
}
function scroll(viewport, direction, smoothScrolling) {
  if (!viewport) {
    return;
  }

  // Space within this scroll margin on the top and bottom is considered to be "offscreen" in the below algorithm.
  const scrollMargin = 64;
  let newPosition;
  if (direction === 'down') {
    // Scroll down by one full viewport by default (this could happen if only a single child element exists)
    newPosition = viewport.scrollTop + (viewport.clientHeight - 2 * scrollMargin);

    // Scroll so that an element partially in view on the bottom (or the first offscreen
    // element if no elements are partially in view) ends up at the far top.
    const viewportScrollBottom = viewport.scrollTop + viewport.clientHeight;
    for (const child of viewport.children) {
      const offsetBottom = child.offsetTop + child.clientHeight;
      // Element is at least partially offscreen to the bottom
      if (offsetBottom > viewportScrollBottom - scrollMargin) {
        // Element is not already scrolled to (this could happen if the element height exceeds the viewport height)
        if (child.offsetTop - scrollMargin > viewport.scrollTop) {
          newPosition = child.offsetTop - scrollMargin;
          break;
        }
      }
    }
  } else {
    // Scroll up by one full viewport by default (this could happen if only a single child element exists)
    newPosition = viewport.scrollTop - (viewport.clientHeight - 2 * scrollMargin);

    // Scroll so that an element partially in view on the top (or the first offscreen
    // element if no elements are partially in view) ends up at the far bottom.
    for (const child of [...viewport.children].reverse()) {
      const offsetBottom = child.offsetTop + child.clientHeight;
      // Element is at least partially offscreen to the top
      if (child.offsetTop < viewport.scrollTop + scrollMargin) {
        // Element is not already scrolled to (this could happen if the element height exceeds the viewport height)
        if (offsetBottom + scrollMargin - viewport.clientHeight < viewport.scrollTop) {
          newPosition = offsetBottom + scrollMargin - viewport.clientHeight;
          break;
        }
      }
    }
  }
  if (smoothScrolling) {
    viewport.scrollTo({
      top: newPosition,
      left: 0,
      behavior: 'smooth'
    });
  } else {
    viewport.scrollTop = newPosition;
  }
}

/**
 * A vertically scrollable region that dynamically shows paging arrows based on scroll position.
 */
function VerticalScrollable(props) {
  const {
    children,
    className: callerClassName,
    tag,
    viewportClassName: callerViewportClassName,
    viewportRole
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const {
    prefersReducedMotion
  } = useMediaFeatures();
  const smoothScrolling = typeof window !== 'undefined' && !prefersReducedMotion && 'scrollBehavior' in document.documentElement.style;
  const [showUpArrow, setShowUpArrow] = useState(false);
  const [showDownArrow, setShowDownArrow] = useState(false);
  const className = classNames('dsx-component', styles['wrapper'], callerClassName);
  const viewportClassName = classNames(callerViewportClassName, styles['viewport'], showUpArrow && styles['up'], showDownArrow && styles['down']);
  const ref = useRef(null);

  // Needs to be regular effect instaed of layout effect.
  // Essentially after initial render check if arrows need to show
  // otherwise styles with transitions will flash from user-agent defaults
  // to specified styles
  useEffect(() => {
    if (ref.current !== null) {
      updateArrowVisibility(ref.current, setShowUpArrow, setShowDownArrow);
    }
  }, [ref, setShowUpArrow, setShowDownArrow]);
  useResizeObserver({
    ref,
    onResize: () => {
      if (!ref.current) {
        return;
      }
      updateArrowVisibility(ref.current, setShowUpArrow, setShowDownArrow);
    }
  });
  const handleViewportScroll = useCallback(e => {
    updateArrowVisibility(e.currentTarget, setShowUpArrow, setShowDownArrow);
  }, [setShowUpArrow, setShowDownArrow]);
  const handleScrollUp = useCallback(() => {
    scroll(ref.current, 'up', smoothScrolling);
  }, [ref, smoothScrolling]);
  const handleScrollDown = useCallback(() => {
    scroll(ref.current, 'down', smoothScrolling);
  }, [ref, smoothScrolling]);
  const contextValue = useMemo(() => ({
    showUpArrow,
    showDownArrow
  }), [showUpArrow, showDownArrow]);
  return /*#__PURE__*/jsx(VerticalScrollableContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/jsxs("div", {
      className: className,
      "data-dsx--vertical-scrollable": tag,
      children: [/*#__PURE__*/jsx("div", {
        className: viewportClassName,
        ref: ref,
        onScroll: handleViewportScroll,
        role: viewportRole,
        children: children
      }), showUpArrow && /*#__PURE__*/jsx("div", {
        className: styles['arrow-up'],
        "data-dsx--vertical-scrollable--up": tag,
        children: /*#__PURE__*/jsx(Button, {
          variant: "ui-control",
          size: "small",
          icon: MdExpandLess,
          iconOnly: true,
          onClick: handleScrollUp,
          children: formatMessage('scroll_up')
        })
      }), showDownArrow && /*#__PURE__*/jsx("div", {
        className: styles['arrow-down'],
        "data-dsx--vertical-scrollable--down": tag,
        children: /*#__PURE__*/jsx(Button, {
          variant: "ui-control",
          size: "small",
          icon: MdExpandMore,
          iconOnly: true,
          onClick: handleScrollDown,
          children: formatMessage('scroll_down')
        })
      })]
    })
  });
}

export { HorizontalScrollable, HorizontalScrollableContext, VerticalScrollable, VerticalScrollableContext };
